import React from "react";
import StockExchangeSection from "../../components/Investor/StockExchange.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const StockExchange = () => {
  return (
    <div>
      <MetaComponent
        title="Financial Statement Disclosure and Stock Filings | Aptech Limited"
        desc="Aptech Limited provides timely financial statement disclosure and transparent filing with the stock exchange to ensure investor confidence and compliance. Learn more."
        keywords="aptech stock exchanges, stock exchange update "
      />
      <StockExchangeSection />
    </div>
  );
};

export default StockExchange;
